export enum EmailListEnum {
    // Main lists
    ONNIT_NEWSLETTER = "list_onnit_newsletter",
    ONNIT_SPECIAL_OFFERS = "list_onnit_special_offers",
    ONNIT_ACADEMY = "list_onnit_academy",

    // Product trial lists
    TRIAL_NEW_MOOD = "list_trial_new_mood",
    TRIAL_SHROOM_TECH_SPORT = "list_trial_shroom_tech_sport",
    TRIAL_ALPHA_BRAIN = "list_trial_alpha_brain",

    // One-off random lists
    PAGE_KETTLEBELLS = "list_page_kettlebells",
    PAGE_NEW_MOOD_FUNNEL = "list_page_new_mood",
    PAGE_SEMI_ANNUAL_SALE = "list_page_semi_annual_sale",
    PAGE_MARVEL = "list_page_marvel",
    PAGE_AUBREY_MARCUS = "list_page_aubrey_marcus",
    PAGE_COWBOY_CERRONE = "list_page_cowboy_cerrone",
    PAGE_STEEL_MACE = "list_page_steel_mace",
}

export enum EmailLeadSourceEnum {
    ONNIT_NEWSLETTER = "onnit:newsletter",
    CLICKBANK = "clickbank",
}
